export default "__VITE_ASSET__Dtt9yg4N__"